var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0829 8.09091C46.4077 6.7382 42.4382 6 38.2972 6C19.3554 6 4 21.4462 4 40.5C4 59.5538 19.3554 75 38.2972 75C57.2391 75 72.5945 59.5538 72.5945 40.5C72.5945 38.0669 72.3441 35.6927 71.8678 33.4019",
    stroke: "#00821E",
    strokeWidth: 7.245
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7598 29.7537L15.1553 35.2317L40.8782 61.8061C49.9624 40.0804 68.3778 19.3415 76.45 11.6878L74.8279 7.9581C58.05 17.7953 42.3459 34.513 36.5911 41.6422L21.7598 29.7537Z",
    fill: "#00821E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.82910ac1ce7bd0b1479b0e027eff100f.svg";
export { ForwardRef as ReactComponent };